import { useParams, Link } from 'react-router-dom';
import { articles, categories } from '@/mocks/articles';

export default function CategoryHeader() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const categoryArticles = articles.filter((a) => a.categorySlug === slug);
  const displayName = category?.name || slug || '';

  return (
    <section className="w-full bg-background-100 pt-24 pb-16 md:pt-32 md:pb-24">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-10">
        <nav className="flex items-center gap-2 text-xs text-foreground-400 mb-8" aria-label="面包屑导航">
          <Link to="/" className="hover:text-accent-500 transition-colors">首页</Link>
          <i className="ri-arrow-right-s-line w-3 h-3 flex items-center justify-center" />
          <span className="text-foreground-700 font-medium">{displayName}</span>
        </nav>

        <div className="flex flex-col lg:flex-row lg:items-start gap-8 lg:gap-16">
          <div className="lg:w-2/5">
            <p className="text-xs text-foreground-500 font-medium mb-3 tracking-wide uppercase">
              分类 · {category?.count || 0}篇
            </p>
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight">
              {displayName}
            </h1>
            {category?.description && (
              <p className="mt-4 text-foreground-500 text-sm leading-relaxed max-w-md">
                {category.description}
              </p>
            )}
          </div>

          <div className="lg:w-3/5 flex gap-4">
            <div className="w-2/5 rounded-2xl overflow-hidden">
              <img
                src={categoryArticles[0]?.imageUrl || 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20composition%20with%20warm%20cream%20and%20coral%20tones%2C%20artistic%20background%2C%20modern%20minimal%20design&width=600&height=400&seq=cat-default-01&orientation=landscape'}
                alt={displayName}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="w-3/5 rounded-2xl overflow-hidden">
              <img
                src={categoryArticles[1]?.imageUrl || 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20composition%20with%20mint%20green%20and%20warm%20golden%20tones%2C%20artistic%20background%2C%20modern%20minimal%20design&width=900&height=400&seq=cat-default-02&orientation=landscape'}
                alt={displayName}
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}